/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BreakReportsList,
    BreakReportsListFromJSON,
    BreakReportsListToJSON,
    BreaksRequest,
    BreaksRequestFromJSON,
    BreaksRequestToJSON,
    GoCancelRequest,
    GoCancelRequestFromJSON,
    GoCancelRequestToJSON,
    GoCancelsList,
    GoCancelsListFromJSON,
    GoCancelsListToJSON,
    NeighborPickupsList,
    NeighborPickupsListFromJSON,
    NeighborPickupsListToJSON,
    NeighborsRequest,
    NeighborsRequestFromJSON,
    NeighborsRequestToJSON,
    ShiftReportsList,
    ShiftReportsListFromJSON,
    ShiftReportsListToJSON,
    ShiftsRequest,
    ShiftsRequestFromJSON,
    ShiftsRequestToJSON,
    TripsReportsList,
    TripsReportsListFromJSON,
    TripsReportsListToJSON,
    TripsRequest,
    TripsRequestFromJSON,
    TripsRequestToJSON,
} from '../models';

export interface GetBreaksReportRequest {
    breaksRequest?: BreaksRequest;
}

export interface GetGoCancelsRequest {
    goCancelRequest?: GoCancelRequest;
}

export interface GetNeighborReportsRequest {
    neighborsRequest?: NeighborsRequest;
}

export interface GetShiftReportsRequest {
    shiftsRequest?: ShiftsRequest;
}

export interface GetTripsReportRequest {
    tripsRequest?: TripsRequest;
}

/**
 * 
 */
export class ShiftReportsApi extends runtime.BaseAPI {

    /**
     * 休憩リポート
     */
    async getBreaksReportRaw(requestParameters: GetBreaksReportRequest): Promise<runtime.ApiResponse<BreakReportsList>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/breaks_report`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BreaksRequestToJSON(requestParameters.breaksRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BreakReportsListFromJSON(jsonValue));
    }

    /**
     * 休憩リポート
     */
    async getBreaksReport(requestParameters: GetBreaksReportRequest): Promise<BreakReportsList> {
        const response = await this.getBreaksReportRaw(requestParameters);
        return await response.value();
    }

    /**
     * GOキャンセル地点
     */
    async getGoCancelsRaw(requestParameters: GetGoCancelsRequest): Promise<runtime.ApiResponse<GoCancelsList>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/go_cancel_locations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GoCancelRequestToJSON(requestParameters.goCancelRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GoCancelsListFromJSON(jsonValue));
    }

    /**
     * GOキャンセル地点
     */
    async getGoCancels(requestParameters: GetGoCancelsRequest): Promise<GoCancelsList> {
        const response = await this.getGoCancelsRaw(requestParameters);
        return await response.value();
    }

    /**
     * 他社乗車のリポート
     */
    async getNeighborReportsRaw(requestParameters: GetNeighborReportsRequest): Promise<runtime.ApiResponse<NeighborPickupsList>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/neighbor_reports`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NeighborsRequestToJSON(requestParameters.neighborsRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => NeighborPickupsListFromJSON(jsonValue));
    }

    /**
     * 他社乗車のリポート
     */
    async getNeighborReports(requestParameters: GetNeighborReportsRequest): Promise<NeighborPickupsList> {
        const response = await this.getNeighborReportsRaw(requestParameters);
        return await response.value();
    }

    /**
     * 乗務リポート
     */
    async getShiftReportsRaw(requestParameters: GetShiftReportsRequest): Promise<runtime.ApiResponse<ShiftReportsList>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/shift_reports`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShiftsRequestToJSON(requestParameters.shiftsRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ShiftReportsListFromJSON(jsonValue));
    }

    /**
     * 乗務リポート
     */
    async getShiftReports(requestParameters: GetShiftReportsRequest): Promise<ShiftReportsList> {
        const response = await this.getShiftReportsRaw(requestParameters);
        return await response.value();
    }

    /**
     * ナビ利用リポート
     */
    async getTripsReportRaw(requestParameters: GetTripsReportRequest): Promise<runtime.ApiResponse<TripsReportsList>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/trips_report`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TripsRequestToJSON(requestParameters.tripsRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TripsReportsListFromJSON(jsonValue));
    }

    /**
     * ナビ利用リポート
     */
    async getTripsReport(requestParameters: GetTripsReportRequest): Promise<TripsReportsList> {
        const response = await this.getTripsReportRaw(requestParameters);
        return await response.value();
    }

}
